// // // import React, { useState } from "react";
// // // import { WebApiURL } from "../Constants/Constants";

// // // function OtpVerifyForm({ setActiveForm }) {
// // //     const [otp, setOtp] = useState("");
// // //     const [statusMessage, setStatusMessage] = useState("");
// // //     const [isSubmitting, setIsSubmitting] = useState(false);

// // //     const handleSubmit = async (e) => {
// // //         e.preventDefault();
// // //         setStatusMessage("");
// // //         setIsSubmitting(true);

// // //         try {
// // //             const email = localStorage.getItem("email");
// // //             if (!email) {
// // //                 setStatusMessage("Session expired. Please log in again.");
// // //                 setIsSubmitting(false);
// // //                 return;
// // //             }

// // //             const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// // //                 method: "POST",
// // //                 headers: { "Content-Type": "application/json" },
// // //                 body: JSON.stringify({ email, otp }),
// // //             });

// // //             const data = await response.json();

// // //             if (response.ok) {
// // //                 setStatusMessage("✅ OTP verified successfully!");
// // //                 setTimeout(() => setActiveForm("verify"), 500);
// // //             } else {
// // //                 setStatusMessage(data.message || "Invalid OTP. Please try again.");
// // //             }
// // //         } catch (error) {
// // //             console.error(error);
// // //             setStatusMessage("Invalid OTP. Please try again.");
// // //         } finally {
// // //             setIsSubmitting(false);
// // //         }
// // //     };

// // //     return (
// // //         <div className="max-564 w-100 rounded-1 border p-4">
// // //             <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// // //                 OTP Verification
// // //             </div>

// // //             {statusMessage && (
// // //                 <div
// // //                     className={`alert ${statusMessage.includes("success")
// // //                         ? "alert-success"
// // //                         : "alert-danger"
// // //                         }`}
// // //                 >
// // //                     {statusMessage}
// // //                 </div>
// // //             )}

// // //             <form onSubmit={handleSubmit}>
// // //                 <div className="form-group mb-3">
// // //                     <label
// // //                         htmlFor="otp"
// // //                         className="form-label font-17 font-400 text-primary-green mb-1"
// // //                     >Enter OTP
// // //                     </label>
// // //                     <input
// // //                         type="text"
// // //                         className="form-control height-40 rounded-1 border-color-7D9199"
// // //                         id="otp"
// // //                         placeholder="Enter the code sent to your email"
// // //                         value={otp}
// // //                         onChange={(e) => setOtp(e.target.value)}
// // //                         required
// // //                     />
// // //                 </div>

// // //                 <div className="form-group mb-3">
// // //                     <button
// // //                         type="submit"
// // //                         className="btn btn-primary-green w-100 height-50 rounded-1"
// // //                         disabled={isSubmitting}
// // //                     >
// // //                         {isSubmitting ? "Verifying..." : "Verify OTP"}
// // //                     </button>
// // //                 </div>

// // //                 <div className="form-group d-flex justify-content-between">
// // //                     <button
// // //                         type="button"
// // //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //                         onClick={() => setActiveForm("login")}
// // //                     >
// // //                         ← Back to Login
// // //                     </button>
// // //                     <button
// // //                         type="button"
// // //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //                         onClick={() => setActiveForm("resend")}
// // //                     >
// // //                         Resend OTP
// // //                     </button>
// // //                 </div>
// // //             </form>
// // //         </div>
// // //     );
// // // }

// // // export default OtpVerifyForm;


// // // import React, { useState, useRef } from "react";
// // // import { WebApiURL } from "../Constants/Constants";

// // // function OtpVerifyForm({ setActiveForm }) {
// // //     const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// // //     const [statusMessage, setStatusMessage] = useState("");
// // //     const [isSubmitting, setIsSubmitting] = useState(false);

// // //     const inputsRef = useRef([]);

// // //     const handleChange = (index, value) => {
// // //         if (!/^[0-9]?$/.test(value)) return;

// // //         const newOtp = [...otpDigits];
// // //         newOtp[index] = value;
// // //         setOtpDigits(newOtp);

// // //         // Move to next input if digit entered
// // //         if (value && index < 5) {
// // //             inputsRef.current[index + 1]?.focus();
// // //         }
// // //     };

// // //     const handleKeyDown = (index, e) => {
// // //         if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// // //             inputsRef.current[index - 1]?.focus();
// // //         }
// // //     };

// // //     const handleSubmit = async (e) => {
// // //         e.preventDefault();
// // //         const otp = otpDigits.join("");

// // //         setStatusMessage("");
// // //         setIsSubmitting(true);

// // //         try {
// // //             const userId = localStorage.getItem("userId");
// // //             if (!userId) {
// // //                 setStatusMessage("Session expired. Please log in again.");
// // //                 setIsSubmitting(false);
// // //                 return;
// // //             }

// // //             const email = localStorage.getItem("email");
// // //             const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// // //                 method: "POST",
// // //                 headers: { "Content-Type": "application/json" },
// // //                 body: JSON.stringify({ email, otp }),
// // //             });

// // //             const text = await response.text();

// // //             let data;
// // //             try {
// // //                 data = JSON.parse(text);
// // //             } catch {
// // //                 data = { message: text };
// // //             }

// // //             if (response.ok) {
// // //                 setStatusMessage("✅ OTP verified successfully!");
// // //                 setTimeout(() => {
// // //                     setActiveForm("verify");
// // //                 }, 500);
// // //             } else {
// // //                 setStatusMessage(data.message || "Invalid OTP. Please try again.");
// // //             }
// // //         } catch (error) {
// // //             console.error(error);
// // //             setStatusMessage("Server error or network issue.");
// // //         } finally {
// // //             setIsSubmitting(false);
// // //         }
// // //     };

// // //     return (
// // //         <div className="max-564 w-100 rounded-1 border p-4">
// // //             <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// // //                 OTP Verification
// // //             </div>

// // //             {statusMessage && (
// // //                 <div
// // //                     className={`alert ${statusMessage.includes("success")
// // //                         ? "alert-success"
// // //                         : "alert-danger"
// // //                         }`}
// // //                 >
// // //                     {statusMessage}
// // //                 </div>
// // //             )}

// // //             <form onSubmit={handleSubmit}>
// // //                 <div className="form-group mb-3">
// // //                     <label className="form-label font-17 font-400 text-primary-green mb-1">
// // //                         Enter OTP
// // //                     </label>

// // //                     <div className="d-flex justify-content-between gap-2">
// // //                         {otpDigits.map((digit, index) => (
// // //                             <input
// // //                                 key={index}
// // //                                 type="text"
// // //                                 inputMode="numeric"
// // //                                 maxLength="1"
// // //                                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
// // //                                 value={digit}
// // //                                 onChange={(e) => handleChange(index, e.target.value)}
// // //                                 onKeyDown={(e) => handleKeyDown(index, e)}
// // //                                 ref={(el) => (inputsRef.current[index] = el)}
// // //                             />
// // //                         ))}
// // //                     </div>
// // //                 </div>

// // //                 <div className="form-group mb-3 mt-3">
// // //                     <button
// // //                         type="submit"
// // //                         className="btn btn-primary-green w-100 height-50 rounded-1"
// // //                         disabled={isSubmitting}
// // //                     >
// // //                         {isSubmitting ? "Verifying..." : "Verify OTP"}
// // //                     </button>
// // //                 </div>

// // //                 <div className="form-group d-flex justify-content-between">
// // //                     <button
// // //                         type="button"
// // //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //                         onClick={() => setActiveForm("login")}
// // //                     >
// // //                         ← Back to Login
// // //                     </button>
// // //                     <button
// // //                         type="button"
// // //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //                         onClick={() => setActiveForm("resend")}
// // //                     >
// // //                         Resend OTP
// // //                     </button>
// // //                 </div>
// // //             </form>
// // //         </div>
// // //     );
// // // }

// // // export default OtpVerifyForm;

// // // import React, { useState, useRef } from "react";
// // // import { WebApiURL } from "../Constants/Constants";

// // // function OtpVerifyForm({ setActiveForm }) {
// // //     const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// // //     const [statusMessage, setStatusMessage] = useState("");
// // //     const [isSubmitting, setIsSubmitting] = useState(false);

// // //     const inputsRef = useRef([]);

// // //     const handleChange = (index, value) => {
// // //         if (!/^[0-9]?$/.test(value)) return;

// // //         const newOtp = [...otpDigits];
// // //         newOtp[index] = value;
// // //         setOtpDigits(newOtp);

// // //         // Move to next input if digit entered
// // //         if (value && index < 5) {
// // //             inputsRef.current[index + 1]?.focus();
// // //         }
// // //     };

// // //     const handleKeyDown = (index, e) => {
// // //         if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// // //             inputsRef.current[index - 1]?.focus();
// // //         }
// // //     };

// // //     const handleSubmit = async (e) => {
// // //         e.preventDefault();
// // //         const otp = otpDigits.join("");

// // //         setStatusMessage("");
// // //         setIsSubmitting(true);

// // //         try {
// // //             const userId = localStorage.getItem("userId");
// // //             // if (!userId) {
// // //             //     setStatusMessage("Session expired. Please log in again.");
// // //             //     setIsSubmitting(false);
// // //             //     return;
// // //             // }

// // //             const email = localStorage.getItem("email");
// // //             const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// // //                 method: "POST",
// // //                 headers: { "Content-Type": "application/json" },
// // //                 body: JSON.stringify({ email, otp }),
// // //             });

// // //             const text = await response.text();

// // //             let data;
// // //             try {
// // //                 data = JSON.parse(text);
// // //             } catch {
// // //                 data = { message: text };
// // //             }

// // //             if (response.ok) {
// // //                 setStatusMessage("✅ OTP verified successfully!");
// // //                 setTimeout(() => {
// // //                     setActiveForm("verify");
// // //                 }, 500);
// // //             } else {
// // //                 setStatusMessage(data.message || "Invalid OTP. Please try again.");
// // //             }
// // //         } catch (error) {
// // //             console.error(error);
// // //             setStatusMessage("Server error or network issue.");
// // //         } finally {
// // //             setIsSubmitting(false);
// // //         }
// // //     };

// // //     return (
// // //         <div className="max-564 w-100 rounded-1 border p-4">
// // //             <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// // //                 OTP Verification
// // //             </div>

// // //             {statusMessage && (
// // //                 <div
// // //                     className={`alert ${
// // //                         statusMessage.includes("success")
// // //                             ? "alert-success"
// // //                             : "alert-danger"
// // //                     }`}
// // //                 >
// // //                     {statusMessage}
// // //                 </div>
// // //             )}

// // //             <form onSubmit={handleSubmit}>
// // //                 <div className="form-group mb-3">
// // //                     <label className="form-label font-17 font-400 text-primary-green mb-1">
// // //                         Enter OTP
// // //                     </label>

// // //                     {/* OTP Boxes */}
// // //                     <div className="d-flex justify-content-center gap-2">
// // //                         {otpDigits.map((digit, index) => (
// // //                             <input
// // //                                 key={index}
// // //                                 type="text"
// // //                                 inputMode="numeric"
// // //                                 maxLength="1"
// // //                                 className="form-control text-center rounded-1 border-color-7D9199"
// // //                                 style={{
// // //                                     width: "60px",       // ✅ bigger width
// // //                                     height: "60px",      // ✅ bigger height
// // //                                     fontSize: "24px",    // ✅ larger text
// // //                                     fontWeight: "600",   // ✅ bold
// // //                                 }}
// // //                                 value={digit}
// // //                                 onChange={(e) => handleChange(index, e.target.value)}
// // //                                 onKeyDown={(e) => handleKeyDown(index, e)}
// // //                                 ref={(el) => (inputsRef.current[index] = el)}
// // //                             />
// // //                         ))}
// // //                     </div>
// // //                 </div>

// // //                 <div className="form-group mb-3 mt-3">
// // //                     <button
// // //                         type="submit"
// // //                         className="btn btn-primary-green w-100 height-50 rounded-1"
// // //                         disabled={isSubmitting}
// // //                     >
// // //                         {isSubmitting ? "Verifying..." : "Verify OTP"}
// // //                     </button>
// // //                 </div>

// // //                 <div className="form-group d-flex justify-content-between">
// // //                     <button
// // //                         type="button"
// // //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //                         onClick={() => setActiveForm("login")}
// // //                     >
// // //                         ← Back to Login
// // //                     </button>
// // //                     <button
// // //                         type="button"
// // //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //                         onClick={() => setActiveForm("resend")}
// // //                     >
// // //                         Resend OTP
// // //                     </button>
// // //                 </div>
// // //             </form>
// // //         </div>
// // //     );
// // // }

// // // export default OtpVerifyForm;


// // // import React, { useState, useRef } from "react";
// // // import { WebApiURL } from "../Constants/Constants";

// // // function OtpVerifyForm({ setActiveForm, source }) {
// // //   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// // //   const [statusMessage, setStatusMessage] = useState("");
// // //   const [isSubmitting, setIsSubmitting] = useState(false);
// // //   const inputsRef = useRef([]);

// // //   const handleChange = (index, value) => {
// // //     if (!/^[0-9]?$/.test(value)) return;
// // //     const newOtp = [...otpDigits];
// // //     newOtp[index] = value;
// // //     setOtpDigits(newOtp);

// // //     if (value && index < 5) inputsRef.current[index + 1]?.focus();
// // //   };

// // //   const handleKeyDown = (index, e) => {
// // //     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// // //       inputsRef.current[index - 1]?.focus();
// // //     }
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     const otp = otpDigits.join("");
// // //     setStatusMessage("");
// // //     setIsSubmitting(true);

// // //     try {
// // //       const userId = localStorage.getItem("userId");
// // //       const email = localStorage.getItem("email");
// // //       if (!userId || !email) {
// // //         setStatusMessage("Session expired. Please try again.");
// // //         setIsSubmitting(false);
// // //         return;
// // //       }

// // //       const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/json" },
// // //         body: JSON.stringify({ email, otp }),
// // //       });

// // //       const text = await response.text();
// // //       let data;
// // //       try { data = JSON.parse(text); } catch { data = { message: text }; }

// // //       if (response.ok) {
// // //         setStatusMessage("✅ OTP verified successfully!");
// // //         localStorage.removeItem("userId");
// // //         localStorage.removeItem("email");

// // //         setTimeout(() => {
// // //           if (source === "register") setActiveForm("login");
// // //           else if (source === "login") setActiveForm("verify");
// // //         }, 500);
// // //       } else {
// // //         setStatusMessage(data.message || "Invalid OTP. Please try again.");
// // //       }
// // //     } catch (error) {
// // //       console.error(error);
// // //       setStatusMessage("Server error or network issue.");
// // //     } finally {
// // //       setIsSubmitting(false);
// // //     }
// // //   };

// // //   return (
// // //     <div className="max-564 w-100 rounded-1 border p-4">
// // //       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// // //         OTP Verification
// // //       </div>

// // //       {statusMessage && (
// // //         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
// // //           {statusMessage}
// // //         </div>
// // //       )}

// // //       <form onSubmit={handleSubmit}>
// // //         <div className="form-group mb-3">
// // //           <label className="form-label font-17 font-400 text-primary-green mb-1">
// // //             Enter OTP
// // //           </label>
// // //           <div className="d-flex justify-content-center gap-2">
// // //             {otpDigits.map((digit, index) => (
// // //               <input
// // //                 key={index}
// // //                 type="text"
// // //                 inputMode="numeric"
// // //                 maxLength="1"
// // //                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
// // //                 style={{
// // //                   width: "60px",       // ✅ bigger width
// // //                   height: "60px",      // ✅ bigger height
// // //                   fontSize: "24px",    // ✅ larger text
// // //                   fontWeight: "600",   // ✅ bold
// // //                 }}
// // //                 value={digit}
// // //                 onChange={(e) => handleChange(index, e.target.value)}
// // //                 onKeyDown={(e) => handleKeyDown(index, e)}
// // //                 ref={(el) => (inputsRef.current[index] = el)}
// // //               />
// // //             ))}
// // //           </div>
// // //         </div>

// // //         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
// // //           {isSubmitting ? "Verifying..." : "Verify OTP"}
// // //         </button>
// // //         <div className="form-group d-flex justify-content-between">
// // //           <button
// // //             type="button"
// // //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //             onClick={() => setActiveForm("login")}>
// // //             ← Back to Login
// // //           </button>
// // //           {/* <button
// // //             type="button"
// // //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //             onClick={() => setActiveForm("resend")} >
// // //             Resend OTP </button> */}
// // //             </div>
// // //       </form>
// // //     </div>
// // //   );
// // // }

// // // export default OtpVerifyForm;


// // // import React, { useState, useRef, useEffect } from "react";
// // // import { WebApiURL } from "../Constants/Constants";

// // // function OtpVerifyForm({ setActiveForm, source }) {
// // //   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// // //   const [statusMessage, setStatusMessage] = useState("");
// // //   const [isSubmitting, setIsSubmitting] = useState(false);
// // //   const [isResending, setIsResending] = useState(false);

// // //   const inputsRef = useRef([]);


// // //   const handleChange = (index, value) => {
// // //     if (!/^[0-9]?$/.test(value)) return;
// // //     const newOtp = [...otpDigits];
// // //     newOtp[index] = value;
// // //     setOtpDigits(newOtp);
// // //     if (value && index < 5) inputsRef.current[index + 1]?.focus();
// // //   };

// // //   const handleKeyDown = (index, e) => {
// // //     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// // //       inputsRef.current[index - 1]?.focus();
// // //     }
// // //   };

// // //   const handleSubmit = async (e) => {
// // //     e.preventDefault();
// // //     const otp = otpDigits.join("");
// // //     setStatusMessage("");
// // //     setIsSubmitting(true);

// // //     try {
// // //       const email = localStorage.getItem("email");
// // //       const userId = localStorage.getItem("userId");
// // //       if (!email || !userId) {
// // //         setStatusMessage("Session expired. Please try again.");
// // //         setIsSubmitting(false);
// // //         return;
// // //       }

// // //       const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/json" },
// // //         body: JSON.stringify({ email, otp }),
// // //       });

// // //       const text = await response.text();
// // //       let data;
// // //       try { data = JSON.parse(text); } catch { data = { message: text }; }

// // //       if (response.ok) {
// // //         setStatusMessage("✅ OTP verified successfully!");
// // //         localStorage.removeItem("email");
// // //         localStorage.removeItem("userId");

// // //         setTimeout(() => {
// // //           if (source === "register") setActiveForm("login");
// // //           else if (source === "login") setActiveForm("verify");
// // //         }, 500);
// // //       } else {
// // //         setStatusMessage(data.message || "Invalid OTP. Please try again.");
// // //       }
// // //     } catch (err) {
// // //       console.error(err);
// // //       setStatusMessage("Server error or network issue.");
// // //     } finally {
// // //       setIsSubmitting(false);
// // //     }
// // //   };

// // //   const handleResend = async () => {
// // //     setIsResending(true);
// // //     setStatusMessage("");

// // //     try {
// // //       const email = localStorage.getItem("email");
// // //       if (!email) {
// // //         setStatusMessage("Session expired. Please try again.");
// // //         setIsResending(false);
// // //         return;
// // //       }

// // //       // ✅ Call the proper resend-otp endpoint
// // //       const response = await fetch(`${WebApiURL}Verification/resend-otp`, {
// // //         method: "POST",
// // //         headers: { "Content-Type": "application/json" },
// // //         body: JSON.stringify({ email }),
// // //       });

// // //       const text = await response.text();
// // //       let data;
// // //       try { data = JSON.parse(text); } catch { data = { message: text }; }

// // //       if (response.ok) {
// // //         setOtpDigits(["", "", "", "", "", ""]); // Clear input
// // //         inputsRef.current[0]?.focus();          // Focus first input
// // //         setStatusMessage("✅ OTP resent successfully!");
// // //       } else {
// // //         setStatusMessage(data.message || "Failed to resend OTP.");
// // //       }
// // //     } catch (err) {
// // //       console.error(err);
// // //       setStatusMessage("Server error or network issue.");
// // //     } finally {
// // //       setIsResending(false);
// // //     }
// // //   };

// // //   // Auto-hide status messages after 5 seconds
// // //   useEffect(() => {
// // //     if (!statusMessage) return;
// // //     const timer = setTimeout(() => setStatusMessage(""), 5000);
// // //     return () => clearTimeout(timer);
// // //   }, [statusMessage]);

// // //   return (
// // //     <div className="max-564 w-100 rounded-1 border p-4">
// // //       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// // //         OTP Verification
// // //       </div>

// // //       {statusMessage && (
// // //         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
// // //           {statusMessage}
// // //         </div>
// // //       )}

// // //       <form onSubmit={handleSubmit}>
// // //         <div className="form-group mb-3">
// // //           <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
// // //           <div className="d-flex justify-content-center gap-2">
// // //             {otpDigits.map((digit, index) => (
// // //               <input
// // //                 key={index}
// // //                 type="text"
// // //                 inputMode="numeric"
// // //                 maxLength="1"
// // //                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
// // //                 style={{
// // //                   width: "60px",       // ✅ bigger width
// // //                   height: "60px",      // ✅ bigger height
// // //                   fontSize: "24px",    // ✅ larger text
// // //                   fontWeight: "600",   // ✅ bold
// // //                 }}
// // //                 value={digit}
// // //                 onChange={(e) => handleChange(index, e.target.value)}
// // //                 onKeyDown={(e) => handleKeyDown(index, e)}
// // //                 ref={(el) => (inputsRef.current[index] = el)}
// // //               />
// // //             ))}
// // //           </div>
// // //         </div>

// // //         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
// // //           {isSubmitting ? "Verifying..." : "Verify OTP"}
// // //         </button>

// // //         <div className="form-group d-flex justify-content-between mt-3">
// // //           {/* <button
// // //             type="button"
// // //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //             onClick={() => setActiveForm("LoginForm")}>
// // //             ← Back to Login
// // //           </button> */}
// // //           <button
// // //             type="button"
// // //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //             onClick={() => {
// // //               window.location.assign("/services?section=seafarer-verifications");
// // //             }}
// // //           >
// // //             ← Back to Login
// // //           </button>

// // //           <button
// // //             type="button"
// // //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// // //             onClick={handleResend}
// // //             disabled={isResending}
// // //           >
// // //             {isResending ? "Resending..." : "Resend OTP"}
// // //           </button>
// // //         </div>
// // //       </form>
// // //     </div>
// // //   );
// // // }

// // // export default OtpVerifyForm;


// // import React, { useState, useRef, useEffect } from "react";
// // import { WebApiURL } from "../Constants/Constants";

// // function OtpVerifyForm({ setActiveForm, source }) {
// //   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// //   const [statusMessage, setStatusMessage] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [isResending, setIsResending] = useState(false);
// //   const inputsRef = useRef([]);

// //   const handleChange = (index, value) => {
// //     if (!/^[0-9]?$/.test(value)) return;
// //     const newOtp = [...otpDigits];
// //     newOtp[index] = value;
// //     setOtpDigits(newOtp);
// //     if (value && index < 5) inputsRef.current[index + 1]?.focus();
// //   };

// //   const handleKeyDown = (index, e) => {
// //     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// //       inputsRef.current[index - 1]?.focus();
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     const otp = otpDigits.join("");
// //     setStatusMessage("");
// //     setIsSubmitting(true);

// //     try {
// //       const email = localStorage.getItem("email");
// //       if (!email) {
// //         setStatusMessage("Session expired. Please try again.");
// //         setIsSubmitting(false);
// //         return;
// //       }

// //       const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ email, otp }),
// //       });

// //       const text = await response.text();
// //       let data;
// //       try {
// //         data = JSON.parse(text);
// //       } catch {
// //         data = { message: text };
// //       }

// //       if (response.ok) {
// //         setStatusMessage("✅ OTP verified successfully!");

// //         // ✅ Save user info in localStorage
// //         if (data.user) {
// //           localStorage.setItem("user", JSON.stringify(data.user));
// //           localStorage.setItem("role", data.user.Role || "NormalUser"); // store role ✅
// //         }

// //         localStorage.removeItem("email");

// //         setTimeout(() => {
// //           if (source === "register") setActiveForm("login");
// //           else if (source === "login") setActiveForm("verify");
// //         }, 500);
// //       } else {
// //         setStatusMessage(data.message || "Invalid OTP. Please try again.");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setStatusMessage("Server error or network issue.");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const handleResend = async () => {
// //     setIsResending(true);
// //     setStatusMessage("");

// //     try {
// //       const email = localStorage.getItem("email");
// //       if (!email) {
// //         setStatusMessage("Session expired. Please try again.");
// //         setIsResending(false);
// //         return;
// //       }

// //       const response = await fetch(`${WebApiURL}Verification/resend-otp`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ email }),
// //       });

// //       const text = await response.text();
// //       let data;
// //       try {
// //         data = JSON.parse(text);
// //       } catch {
// //         data = { message: text };
// //       }

// //       if (response.ok) {
// //         setOtpDigits(["", "", "", "", "", ""]);
// //         inputsRef.current[0]?.focus();
// //         setStatusMessage("✅ OTP resent successfully!");
// //       } else {
// //         setStatusMessage(data.message || "Failed to resend OTP.");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setStatusMessage("Server error or network issue.");
// //     } finally {
// //       setIsResending(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (!statusMessage) return;
// //     const timer = setTimeout(() => setStatusMessage(""), 5000);
// //     return () => clearTimeout(timer);
// //   }, [statusMessage]);

// //   return (
// //     <div className="max-564 w-100 rounded-1 border p-4">
// //       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// //         OTP Verification
// //       </div>

// //       {statusMessage && (
// //         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
// //           {statusMessage}
// //         </div>
// //       )}

// //       <form onSubmit={handleSubmit}>
// //         <div className="form-group mb-3">
// //           <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
// //           <div className="d-flex justify-content-center gap-2">
// //             {otpDigits.map((digit, index) => (
// //               <input
// //                 key={index}
// //                 type="text"
// //                 inputMode="numeric"
// //                 maxLength="1"
// //                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
// //                 style={{ width: "60px", height: "60px", fontSize: "24px", fontWeight: "600" }}
// //                 value={digit}
// //                 onChange={(e) => handleChange(index, e.target.value)}
// //                 onKeyDown={(e) => handleKeyDown(index, e)}
// //                 ref={(el) => (inputsRef.current[index] = el)}
// //               />
// //             ))}
// //           </div>
// //         </div>

// //         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
// //           {isSubmitting ? "Verifying..." : "Verify OTP"}
// //         </button>

// //         <div className="form-group d-flex justify-content-between mt-3">
// //           <button
// //             type="button"
// //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //             onClick={() => window.location.assign("/services?section=seafarer-verifications")}
// //           >
// //             ← Back to Login
// //           </button>
// //           <button
// //             type="button"
// //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //             onClick={handleResend}
// //             disabled={isResending}
// //           >
// //             {isResending ? "Resending..." : "Resend OTP"}
// //           </button>
// //         </div>
// //       </form>
// //     </div>
// //   );
// // }

// // export default OtpVerifyForm;

// import React, { useState, useRef, useEffect } from "react";
// import { WebApiURL } from "../Constants/Constants";

// function OtpVerifyForm({ setActiveForm, source }) {
//   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
//   const [statusMessage, setStatusMessage] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isResending, setIsResending] = useState(false);
//   const inputsRef = useRef([]);

//   const handleChange = (index, value) => {
//     if (!/^[0-9]?$/.test(value)) return;
//     const newOtp = [...otpDigits];
//     newOtp[index] = value;
//     setOtpDigits(newOtp);
//     if (value && index < 5) inputsRef.current[index + 1]?.focus();
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
//       inputsRef.current[index - 1]?.focus();
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const otp = otpDigits.join("");
//     setStatusMessage("");
//     setIsSubmitting(true);

//     try {
//       const email = localStorage.getItem("email");
//       if (!email) {
//         setStatusMessage("Session expired. Please try again.");
//         setIsSubmitting(false);
//         return;
//       }

//       const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, otp }),
//       });

//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = { message: text };
//       }

//       if (response.ok) {
//         setStatusMessage("✅ OTP verified successfully!");

//         // ✅ Save user info in localStorage
//         if (data.user) {
//           localStorage.setItem("user", JSON.stringify(data.user));
//         }

//         localStorage.removeItem("email");

//         setTimeout(() => {
//           if (source === "register") setActiveForm("login");
//           else if (source === "login") setActiveForm("verify");
//         }, 500);
//       } else {
//         setStatusMessage(data.message || "Invalid OTP. Please try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleResend = async () => {
//     setIsResending(true);
//     setStatusMessage("");

//     try {
//       const email = localStorage.getItem("email");
//       if (!email) {
//         setStatusMessage("Session expired. Please try again.");
//         setIsResending(false);
//         return;
//       }

//       const response = await fetch(`${WebApiURL}Verification/resend-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });

//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = { message: text };
//       }

//       if (response.ok) {
//         setOtpDigits(["", "", "", "", "", ""]);
//         inputsRef.current[0]?.focus();
//         setStatusMessage("✅ OTP resent successfully!");
//       } else {
//         setStatusMessage(data.message || "Failed to resend OTP.");
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsResending(false);
//     }
//   };

//   useEffect(() => {
//     if (!statusMessage) return;
//     const timer = setTimeout(() => setStatusMessage(""), 5000);
//     return () => clearTimeout(timer);
//   }, [statusMessage]);

//   return (
//     <div className="max-564 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
//         OTP Verification
//       </div>

//       {statusMessage && (
//         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
//           {statusMessage}
//         </div>
//       )}

//       <form onSubmit={handleSubmit}>
//         <div className="form-group mb-3">
//           <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
//           {/* <div className="d-flex justify-content-between gap-2">
//             {otpDigits.map((digit, index) => (
//               <input
//                 key={index}
//                 type="text"
//                 inputMode="numeric"
//                 maxLength="1"
//                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
//                 style={{ width: "60px", height: "60px", fontSize: "24px", fontWeight: "600" }}
//                 value={digit}
//                 onChange={(e) => handleChange(index, e.target.value)}
//                 onKeyDown={(e) => handleKeyDown(index, e)}
//                 ref={(el) => (inputsRef.current[index] = el)}
//               />
//             ))}
//           </div>
//         </div> */}
//           <div className="d-flex justify-content-center gap-2">
//             {otpDigits.map((digit, index) => (
//               <input
//                 key={index}
//                 type="text"
//                 inputMode="numeric"
//                 maxLength="1"
//                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
//                 style={{ width: "60px", height: "60px", fontSize: "24px", fontWeight: "600" }}
//                 value={digit}
//                 onChange={(e) => handleChange(index, e.target.value)}
//                 onKeyDown={(e) => handleKeyDown(index, e)}
//                 ref={(el) => (inputsRef.current[index] = el)}
//               />
//             ))}
//           </div>
//         </div>

//         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
//           {isSubmitting ? "Verifying..." : "Verify OTP"}
//         </button>

//         <div className="form-group d-flex justify-content-between mt-3">
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={() => setActiveForm("login")}
//           >
//             ← Back to Login
//           </button>
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={handleResend}
//             disabled={isResending}
//           >
//             {isResending ? "Resending..." : "Resend OTP"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default OtpVerifyForm;

// // import React, { useState } from "react";
// // import { WebApiURL } from "../Constants/Constants";

// // function OtpVerifyForm({ setActiveForm }) {
// //     const [otp, setOtp] = useState("");
// //     const [statusMessage, setStatusMessage] = useState("");
// //     const [isSubmitting, setIsSubmitting] = useState(false);

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         setStatusMessage("");
// //         setIsSubmitting(true);

// //         try {
// //             const email = localStorage.getItem("email");
// //             if (!email) {
// //                 setStatusMessage("Session expired. Please log in again.");
// //                 setIsSubmitting(false);
// //                 return;
// //             }

// //             const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// //                 method: "POST",
// //                 headers: { "Content-Type": "application/json" },
// //                 body: JSON.stringify({ email, otp }),
// //             });

// //             const data = await response.json();

// //             if (response.ok) {
// //                 setStatusMessage("✅ OTP verified successfully!");
// //                 setTimeout(() => setActiveForm("verify"), 500);
// //             } else {
// //                 setStatusMessage(data.message || "Invalid OTP. Please try again.");
// //             }
// //         } catch (error) {
// //             console.error(error);
// //             setStatusMessage("Invalid OTP. Please try again.");
// //         } finally {
// //             setIsSubmitting(false);
// //         }
// //     };

// //     return (
// //         <div className="max-564 w-100 rounded-1 border p-4">
// //             <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// //                 OTP Verification
// //             </div>

// //             {statusMessage && (
// //                 <div
// //                     className={`alert ${statusMessage.includes("success")
// //                         ? "alert-success"
// //                         : "alert-danger"
// //                         }`}
// //                 >
// //                     {statusMessage}
// //                 </div>
// //             )}

// //             <form onSubmit={handleSubmit}>
// //                 <div className="form-group mb-3">
// //                     <label
// //                         htmlFor="otp"
// //                         className="form-label font-17 font-400 text-primary-green mb-1"
// //                     >Enter OTP
// //                     </label>
// //                     <input
// //                         type="text"
// //                         className="form-control height-40 rounded-1 border-color-7D9199"
// //                         id="otp"
// //                         placeholder="Enter the code sent to your email"
// //                         value={otp}
// //                         onChange={(e) => setOtp(e.target.value)}
// //                         required
// //                     />
// //                 </div>

// //                 <div className="form-group mb-3">
// //                     <button
// //                         type="submit"
// //                         className="btn btn-primary-green w-100 height-50 rounded-1"
// //                         disabled={isSubmitting}
// //                     >
// //                         {isSubmitting ? "Verifying..." : "Verify OTP"}
// //                     </button>
// //                 </div>

// //                 <div className="form-group d-flex justify-content-between">
// //                     <button
// //                         type="button"
// //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //                         onClick={() => setActiveForm("login")}
// //                     >
// //                         ← Back to Login
// //                     </button>
// //                     <button
// //                         type="button"
// //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //                         onClick={() => setActiveForm("resend")}
// //                     >
// //                         Resend OTP
// //                     </button>
// //                 </div>
// //             </form>
// //         </div>
// //     );
// // }

// // export default OtpVerifyForm;


// // import React, { useState, useRef } from "react";
// // import { WebApiURL } from "../Constants/Constants";

// // function OtpVerifyForm({ setActiveForm }) {
// //     const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// //     const [statusMessage, setStatusMessage] = useState("");
// //     const [isSubmitting, setIsSubmitting] = useState(false);

// //     const inputsRef = useRef([]);

// //     const handleChange = (index, value) => {
// //         if (!/^[0-9]?$/.test(value)) return;

// //         const newOtp = [...otpDigits];
// //         newOtp[index] = value;
// //         setOtpDigits(newOtp);

// //         // Move to next input if digit entered
// //         if (value && index < 5) {
// //             inputsRef.current[index + 1]?.focus();
// //         }
// //     };

// //     const handleKeyDown = (index, e) => {
// //         if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// //             inputsRef.current[index - 1]?.focus();
// //         }
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         const otp = otpDigits.join("");

// //         setStatusMessage("");
// //         setIsSubmitting(true);

// //         try {
// //             const userId = localStorage.getItem("userId");
// //             if (!userId) {
// //                 setStatusMessage("Session expired. Please log in again.");
// //                 setIsSubmitting(false);
// //                 return;
// //             }

// //             const email = localStorage.getItem("email");
// //             const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// //                 method: "POST",
// //                 headers: { "Content-Type": "application/json" },
// //                 body: JSON.stringify({ email, otp }),
// //             });

// //             const text = await response.text();

// //             let data;
// //             try {
// //                 data = JSON.parse(text);
// //             } catch {
// //                 data = { message: text };
// //             }

// //             if (response.ok) {
// //                 setStatusMessage("✅ OTP verified successfully!");
// //                 setTimeout(() => {
// //                     setActiveForm("verify");
// //                 }, 500);
// //             } else {
// //                 setStatusMessage(data.message || "Invalid OTP. Please try again.");
// //             }
// //         } catch (error) {
// //             console.error(error);
// //             setStatusMessage("Server error or network issue.");
// //         } finally {
// //             setIsSubmitting(false);
// //         }
// //     };

// //     return (
// //         <div className="max-564 w-100 rounded-1 border p-4">
// //             <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// //                 OTP Verification
// //             </div>

// //             {statusMessage && (
// //                 <div
// //                     className={`alert ${statusMessage.includes("success")
// //                         ? "alert-success"
// //                         : "alert-danger"
// //                         }`}
// //                 >
// //                     {statusMessage}
// //                 </div>
// //             )}

// //             <form onSubmit={handleSubmit}>
// //                 <div className="form-group mb-3">
// //                     <label className="form-label font-17 font-400 text-primary-green mb-1">
// //                         Enter OTP
// //                     </label>

// //                     <div className="d-flex justify-content-between gap-2">
// //                         {otpDigits.map((digit, index) => (
// //                             <input
// //                                 key={index}
// //                                 type="text"
// //                                 inputMode="numeric"
// //                                 maxLength="1"
// //                                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
// //                                 value={digit}
// //                                 onChange={(e) => handleChange(index, e.target.value)}
// //                                 onKeyDown={(e) => handleKeyDown(index, e)}
// //                                 ref={(el) => (inputsRef.current[index] = el)}
// //                             />
// //                         ))}
// //                     </div>
// //                 </div>

// //                 <div className="form-group mb-3 mt-3">
// //                     <button
// //                         type="submit"
// //                         className="btn btn-primary-green w-100 height-50 rounded-1"
// //                         disabled={isSubmitting}
// //                     >
// //                         {isSubmitting ? "Verifying..." : "Verify OTP"}
// //                     </button>
// //                 </div>

// //                 <div className="form-group d-flex justify-content-between">
// //                     <button
// //                         type="button"
// //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //                         onClick={() => setActiveForm("login")}
// //                     >
// //                         ← Back to Login
// //                     </button>
// //                     <button
// //                         type="button"
// //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //                         onClick={() => setActiveForm("resend")}
// //                     >
// //                         Resend OTP
// //                     </button>
// //                 </div>
// //             </form>
// //         </div>
// //     );
// // }

// // export default OtpVerifyForm;

// // import React, { useState, useRef } from "react";
// // import { WebApiURL } from "../Constants/Constants";

// // function OtpVerifyForm({ setActiveForm }) {
// //     const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// //     const [statusMessage, setStatusMessage] = useState("");
// //     const [isSubmitting, setIsSubmitting] = useState(false);

// //     const inputsRef = useRef([]);

// //     const handleChange = (index, value) => {
// //         if (!/^[0-9]?$/.test(value)) return;

// //         const newOtp = [...otpDigits];
// //         newOtp[index] = value;
// //         setOtpDigits(newOtp);

// //         // Move to next input if digit entered
// //         if (value && index < 5) {
// //             inputsRef.current[index + 1]?.focus();
// //         }
// //     };

// //     const handleKeyDown = (index, e) => {
// //         if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// //             inputsRef.current[index - 1]?.focus();
// //         }
// //     };

// //     const handleSubmit = async (e) => {
// //         e.preventDefault();
// //         const otp = otpDigits.join("");

// //         setStatusMessage("");
// //         setIsSubmitting(true);

// //         try {
// //             const userId = localStorage.getItem("userId");
// //             // if (!userId) {
// //             //     setStatusMessage("Session expired. Please log in again.");
// //             //     setIsSubmitting(false);
// //             //     return;
// //             // }

// //             const email = localStorage.getItem("email");
// //             const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// //                 method: "POST",
// //                 headers: { "Content-Type": "application/json" },
// //                 body: JSON.stringify({ email, otp }),
// //             });

// //             const text = await response.text();

// //             let data;
// //             try {
// //                 data = JSON.parse(text);
// //             } catch {
// //                 data = { message: text };
// //             }

// //             if (response.ok) {
// //                 setStatusMessage("✅ OTP verified successfully!");
// //                 setTimeout(() => {
// //                     setActiveForm("verify");
// //                 }, 500);
// //             } else {
// //                 setStatusMessage(data.message || "Invalid OTP. Please try again.");
// //             }
// //         } catch (error) {
// //             console.error(error);
// //             setStatusMessage("Server error or network issue.");
// //         } finally {
// //             setIsSubmitting(false);
// //         }
// //     };

// //     return (
// //         <div className="max-564 w-100 rounded-1 border p-4">
// //             <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// //                 OTP Verification
// //             </div>

// //             {statusMessage && (
// //                 <div
// //                     className={`alert ${
// //                         statusMessage.includes("success")
// //                             ? "alert-success"
// //                             : "alert-danger"
// //                     }`}
// //                 >
// //                     {statusMessage}
// //                 </div>
// //             )}

// //             <form onSubmit={handleSubmit}>
// //                 <div className="form-group mb-3">
// //                     <label className="form-label font-17 font-400 text-primary-green mb-1">
// //                         Enter OTP
// //                     </label>

// //                     {/* OTP Boxes */}
// //                     <div className="d-flex justify-content-center gap-2">
// //                         {otpDigits.map((digit, index) => (
// //                             <input
// //                                 key={index}
// //                                 type="text"
// //                                 inputMode="numeric"
// //                                 maxLength="1"
// //                                 className="form-control text-center rounded-1 border-color-7D9199"
// //                                 style={{
// //                                     width: "60px",       // ✅ bigger width
// //                                     height: "60px",      // ✅ bigger height
// //                                     fontSize: "24px",    // ✅ larger text
// //                                     fontWeight: "600",   // ✅ bold
// //                                 }}
// //                                 value={digit}
// //                                 onChange={(e) => handleChange(index, e.target.value)}
// //                                 onKeyDown={(e) => handleKeyDown(index, e)}
// //                                 ref={(el) => (inputsRef.current[index] = el)}
// //                             />
// //                         ))}
// //                     </div>
// //                 </div>

// //                 <div className="form-group mb-3 mt-3">
// //                     <button
// //                         type="submit"
// //                         className="btn btn-primary-green w-100 height-50 rounded-1"
// //                         disabled={isSubmitting}
// //                     >
// //                         {isSubmitting ? "Verifying..." : "Verify OTP"}
// //                     </button>
// //                 </div>

// //                 <div className="form-group d-flex justify-content-between">
// //                     <button
// //                         type="button"
// //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //                         onClick={() => setActiveForm("login")}
// //                     >
// //                         ← Back to Login
// //                     </button>
// //                     <button
// //                         type="button"
// //                         className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //                         onClick={() => setActiveForm("resend")}
// //                     >
// //                         Resend OTP
// //                     </button>
// //                 </div>
// //             </form>
// //         </div>
// //     );
// // }

// // export default OtpVerifyForm;


// // import React, { useState, useRef } from "react";
// // import { WebApiURL } from "../Constants/Constants";

// // function OtpVerifyForm({ setActiveForm, source }) {
// //   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// //   const [statusMessage, setStatusMessage] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const inputsRef = useRef([]);

// //   const handleChange = (index, value) => {
// //     if (!/^[0-9]?$/.test(value)) return;
// //     const newOtp = [...otpDigits];
// //     newOtp[index] = value;
// //     setOtpDigits(newOtp);

// //     if (value && index < 5) inputsRef.current[index + 1]?.focus();
// //   };

// //   const handleKeyDown = (index, e) => {
// //     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// //       inputsRef.current[index - 1]?.focus();
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     const otp = otpDigits.join("");
// //     setStatusMessage("");
// //     setIsSubmitting(true);

// //     try {
// //       const userId = localStorage.getItem("userId");
// //       const email = localStorage.getItem("email");
// //       if (!userId || !email) {
// //         setStatusMessage("Session expired. Please try again.");
// //         setIsSubmitting(false);
// //         return;
// //       }

// //       const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ email, otp }),
// //       });

// //       const text = await response.text();
// //       let data;
// //       try { data = JSON.parse(text); } catch { data = { message: text }; }

// //       if (response.ok) {
// //         setStatusMessage("✅ OTP verified successfully!");
// //         localStorage.removeItem("userId");
// //         localStorage.removeItem("email");

// //         setTimeout(() => {
// //           if (source === "register") setActiveForm("login");
// //           else if (source === "login") setActiveForm("verify");
// //         }, 500);
// //       } else {
// //         setStatusMessage(data.message || "Invalid OTP. Please try again.");
// //       }
// //     } catch (error) {
// //       console.error(error);
// //       setStatusMessage("Server error or network issue.");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   return (
// //     <div className="max-564 w-100 rounded-1 border p-4">
// //       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// //         OTP Verification
// //       </div>

// //       {statusMessage && (
// //         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
// //           {statusMessage}
// //         </div>
// //       )}

// //       <form onSubmit={handleSubmit}>
// //         <div className="form-group mb-3">
// //           <label className="form-label font-17 font-400 text-primary-green mb-1">
// //             Enter OTP
// //           </label>
// //           <div className="d-flex justify-content-center gap-2">
// //             {otpDigits.map((digit, index) => (
// //               <input
// //                 key={index}
// //                 type="text"
// //                 inputMode="numeric"
// //                 maxLength="1"
// //                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
// //                 style={{
// //                   width: "60px",       // ✅ bigger width
// //                   height: "60px",      // ✅ bigger height
// //                   fontSize: "24px",    // ✅ larger text
// //                   fontWeight: "600",   // ✅ bold
// //                 }}
// //                 value={digit}
// //                 onChange={(e) => handleChange(index, e.target.value)}
// //                 onKeyDown={(e) => handleKeyDown(index, e)}
// //                 ref={(el) => (inputsRef.current[index] = el)}
// //               />
// //             ))}
// //           </div>
// //         </div>

// //         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
// //           {isSubmitting ? "Verifying..." : "Verify OTP"}
// //         </button>
// //         <div className="form-group d-flex justify-content-between">
// //           <button
// //             type="button"
// //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //             onClick={() => setActiveForm("login")}>
// //             ← Back to Login
// //           </button>
// //           {/* <button
// //             type="button"
// //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //             onClick={() => setActiveForm("resend")} >
// //             Resend OTP </button> */}
// //             </div>
// //       </form>
// //     </div>
// //   );
// // }

// // export default OtpVerifyForm;


// // import React, { useState, useRef, useEffect } from "react";
// // import { WebApiURL } from "../Constants/Constants";

// // function OtpVerifyForm({ setActiveForm, source }) {
// //   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
// //   const [statusMessage, setStatusMessage] = useState("");
// //   const [isSubmitting, setIsSubmitting] = useState(false);
// //   const [isResending, setIsResending] = useState(false);

// //   const inputsRef = useRef([]);


// //   const handleChange = (index, value) => {
// //     if (!/^[0-9]?$/.test(value)) return;
// //     const newOtp = [...otpDigits];
// //     newOtp[index] = value;
// //     setOtpDigits(newOtp);
// //     if (value && index < 5) inputsRef.current[index + 1]?.focus();
// //   };

// //   const handleKeyDown = (index, e) => {
// //     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
// //       inputsRef.current[index - 1]?.focus();
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     const otp = otpDigits.join("");
// //     setStatusMessage("");
// //     setIsSubmitting(true);

// //     try {
// //       const email = localStorage.getItem("email");
// //       const userId = localStorage.getItem("userId");
// //       if (!email || !userId) {
// //         setStatusMessage("Session expired. Please try again.");
// //         setIsSubmitting(false);
// //         return;
// //       }

// //       const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ email, otp }),
// //       });

// //       const text = await response.text();
// //       let data;
// //       try { data = JSON.parse(text); } catch { data = { message: text }; }

// //       if (response.ok) {
// //         setStatusMessage("✅ OTP verified successfully!");
// //         localStorage.removeItem("email");
// //         localStorage.removeItem("userId");

// //         setTimeout(() => {
// //           if (source === "register") setActiveForm("login");
// //           else if (source === "login") setActiveForm("verify");
// //         }, 500);
// //       } else {
// //         setStatusMessage(data.message || "Invalid OTP. Please try again.");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setStatusMessage("Server error or network issue.");
// //     } finally {
// //       setIsSubmitting(false);
// //     }
// //   };

// //   const handleResend = async () => {
// //     setIsResending(true);
// //     setStatusMessage("");

// //     try {
// //       const email = localStorage.getItem("email");
// //       if (!email) {
// //         setStatusMessage("Session expired. Please try again.");
// //         setIsResending(false);
// //         return;
// //       }

// //       // ✅ Call the proper resend-otp endpoint
// //       const response = await fetch(`${WebApiURL}Verification/resend-otp`, {
// //         method: "POST",
// //         headers: { "Content-Type": "application/json" },
// //         body: JSON.stringify({ email }),
// //       });

// //       const text = await response.text();
// //       let data;
// //       try { data = JSON.parse(text); } catch { data = { message: text }; }

// //       if (response.ok) {
// //         setOtpDigits(["", "", "", "", "", ""]); // Clear input
// //         inputsRef.current[0]?.focus();          // Focus first input
// //         setStatusMessage("✅ OTP resent successfully!");
// //       } else {
// //         setStatusMessage(data.message || "Failed to resend OTP.");
// //       }
// //     } catch (err) {
// //       console.error(err);
// //       setStatusMessage("Server error or network issue.");
// //     } finally {
// //       setIsResending(false);
// //     }
// //   };

// //   // Auto-hide status messages after 5 seconds
// //   useEffect(() => {
// //     if (!statusMessage) return;
// //     const timer = setTimeout(() => setStatusMessage(""), 5000);
// //     return () => clearTimeout(timer);
// //   }, [statusMessage]);

// //   return (
// //     <div className="max-564 w-100 rounded-1 border p-4">
// //       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
// //         OTP Verification
// //       </div>

// //       {statusMessage && (
// //         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
// //           {statusMessage}
// //         </div>
// //       )}

// //       <form onSubmit={handleSubmit}>
// //         <div className="form-group mb-3">
// //           <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
// //           <div className="d-flex justify-content-center gap-2">
// //             {otpDigits.map((digit, index) => (
// //               <input
// //                 key={index}
// //                 type="text"
// //                 inputMode="numeric"
// //                 maxLength="1"
// //                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
// //                 style={{
// //                   width: "60px",       // ✅ bigger width
// //                   height: "60px",      // ✅ bigger height
// //                   fontSize: "24px",    // ✅ larger text
// //                   fontWeight: "600",   // ✅ bold
// //                 }}
// //                 value={digit}
// //                 onChange={(e) => handleChange(index, e.target.value)}
// //                 onKeyDown={(e) => handleKeyDown(index, e)}
// //                 ref={(el) => (inputsRef.current[index] = el)}
// //               />
// //             ))}
// //           </div>
// //         </div>

// //         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
// //           {isSubmitting ? "Verifying..." : "Verify OTP"}
// //         </button>

// //         <div className="form-group d-flex justify-content-between mt-3">
// //           {/* <button
// //             type="button"
// //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //             onClick={() => setActiveForm("LoginForm")}>
// //             ← Back to Login
// //           </button> */}
// //           <button
// //             type="button"
// //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //             onClick={() => {
// //               window.location.assign("/services?section=seafarer-verifications");
// //             }}
// //           >
// //             ← Back to Login
// //           </button>

// //           <button
// //             type="button"
// //             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
// //             onClick={handleResend}
// //             disabled={isResending}
// //           >
// //             {isResending ? "Resending..." : "Resend OTP"}
// //           </button>
// //         </div>
// //       </form>
// //     </div>
// //   );
// // }

// // export default OtpVerifyForm;


// import React, { useState, useRef, useEffect } from "react";
// import { WebApiURL } from "../Constants/Constants";

// function OtpVerifyForm({ setActiveForm, source }) {
//   const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
//   const [statusMessage, setStatusMessage] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isResending, setIsResending] = useState(false);
//   const inputsRef = useRef([]);

//   const handleChange = (index, value) => {
//     if (!/^[0-9]?$/.test(value)) return;
//     const newOtp = [...otpDigits];
//     newOtp[index] = value;
//     setOtpDigits(newOtp);
//     if (value && index < 5) inputsRef.current[index + 1]?.focus();
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
//       inputsRef.current[index - 1]?.focus();
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     const otp = otpDigits.join("");
//     setStatusMessage("");
//     setIsSubmitting(true);

//     try {
//       const email = localStorage.getItem("email");
//       if (!email) {
//         setStatusMessage("Session expired. Please try again.");
//         setIsSubmitting(false);
//         return;
//       }

//       const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email, otp }),
//       });

//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = { message: text };
//       }

//       if (response.ok) {
//         setStatusMessage("✅ OTP verified successfully!");

//         // ✅ Save user info in localStorage
//         if (data.user) {
//           localStorage.setItem("user", JSON.stringify(data.user));
//           localStorage.setItem("role", data.user.Role || "NormalUser"); // store role ✅
//         }

//         localStorage.removeItem("email");

//         setTimeout(() => {
//           if (source === "register") setActiveForm("login");
//           else if (source === "login") setActiveForm("verify");
//         }, 500);
//       } else {
//         setStatusMessage(data.message || "Invalid OTP. Please try again.");
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const handleResend = async () => {
//     setIsResending(true);
//     setStatusMessage("");

//     try {
//       const email = localStorage.getItem("email");
//       if (!email) {
//         setStatusMessage("Session expired. Please try again.");
//         setIsResending(false);
//         return;
//       }

//       const response = await fetch(`${WebApiURL}Verification/resend-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ email }),
//       });

//       const text = await response.text();
//       let data;
//       try {
//         data = JSON.parse(text);
//       } catch {
//         data = { message: text };
//       }

//       if (response.ok) {
//         setOtpDigits(["", "", "", "", "", ""]);
//         inputsRef.current[0]?.focus();
//         setStatusMessage("✅ OTP resent successfully!");
//       } else {
//         setStatusMessage(data.message || "Failed to resend OTP.");
//       }
//     } catch (err) {
//       console.error(err);
//       setStatusMessage("Server error or network issue.");
//     } finally {
//       setIsResending(false);
//     }
//   };

//   useEffect(() => {
//     if (!statusMessage) return;
//     const timer = setTimeout(() => setStatusMessage(""), 5000);
//     return () => clearTimeout(timer);
//   }, [statusMessage]);

//   return (
//     <div className="max-564 w-100 rounded-1 border p-4">
//       <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
//         OTP Verification
//       </div>

//       {statusMessage && (
//         <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
//           {statusMessage}
//         </div>
//       )}

//       <form onSubmit={handleSubmit}>
//         <div className="form-group mb-3">
//           <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
//           <div className="d-flex justify-content-center gap-2">
//             {otpDigits.map((digit, index) => (
//               <input
//                 key={index}
//                 type="text"
//                 inputMode="numeric"
//                 maxLength="1"
//                 className="form-control text-center height-40 rounded-1 border-color-7D9199"
//                 style={{ width: "60px", height: "60px", fontSize: "24px", fontWeight: "600" }}
//                 value={digit}
//                 onChange={(e) => handleChange(index, e.target.value)}
//                 onKeyDown={(e) => handleKeyDown(index, e)}
//                 ref={(el) => (inputsRef.current[index] = el)}
//               />
//             ))}
//           </div>
//         </div>

//         <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
//           {isSubmitting ? "Verifying..." : "Verify OTP"}
//         </button>

//         <div className="form-group d-flex justify-content-between mt-3">
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={() => window.location.assign("/services?section=seafarer-verifications")}
//           >
//             ← Back to Login
//           </button>
//           <button
//             type="button"
//             className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
//             onClick={handleResend}
//             disabled={isResending}
//           >
//             {isResending ? "Resending..." : "Resend OTP"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }

// export default OtpVerifyForm;

import React, { useState, useRef, useEffect } from "react";
import { WebApiURL } from "../Constants/Constants";

function OtpVerifyForm({ setActiveForm, source }) {
  const [otpDigits, setOtpDigits] = useState(["", "", "", "", "", ""]);
  const [statusMessage, setStatusMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const inputsRef = useRef([]);

  const handleChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newOtp = [...otpDigits];
    newOtp[index] = value;
    setOtpDigits(newOtp);
    if (value && index < 5) inputsRef.current[index + 1]?.focus();
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otpDigits[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const otp = otpDigits.join("");
    setStatusMessage("");
    setIsSubmitting(true);

    try {
      const email = localStorage.getItem("email");
      if (!email) {
        setStatusMessage("Session expired. Please try again.");
        setIsSubmitting(false);
        return;
      }

      const response = await fetch(`${WebApiURL}Verification/verify-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp }),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }

      if (response.ok) {
        setStatusMessage("✅ OTP verified successfully!");

        // ✅ Save user info in localStorage
       // if (data.user) {
        //  localStorage.setItem("user", JSON.stringify(data.user));
        //  console.log("✅ User object saved in localStorage:", data.user); // 👈 add this line
       // }

        localStorage.removeItem("email");

        setTimeout(() => {
          if (source === "register") setActiveForm("login");
          else if (source === "login") setActiveForm("verify");
        }, 500);
      } else {
        setStatusMessage(data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setStatusMessage("Server error or network issue.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleResend = async () => {
    setIsResending(true);
    setStatusMessage("");

    try {
      const email = localStorage.getItem("email");
      if (!email) {
        setStatusMessage("Session expired. Please try again.");
        setIsResending(false);
        return;
      }

      const response = await fetch(`${WebApiURL}Verification/resend-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const text = await response.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        data = { message: text };
      }

      if (response.ok) {
        setOtpDigits(["", "", "", "", "", ""]);
        inputsRef.current[0]?.focus();
        setStatusMessage("✅ OTP resent successfully!");
      } else {
        setStatusMessage(data.message || "Failed to resend OTP.");
      }
    } catch (err) {
      console.error(err);
      setStatusMessage("Server error or network issue.");
    } finally {
      setIsResending(false);
    }
  };

  useEffect(() => {
    if (!statusMessage) return;
    const timer = setTimeout(() => setStatusMessage(""), 5000);
    return () => clearTimeout(timer);
  }, [statusMessage]);

  return (
    <div className="max-564 w-100 rounded-1 border p-4">
      <div className="font-24 font-700 mb-4 text-center text-primary-green text-uppercase border-bottom pb-2">
        OTP Verification
      </div>

      {statusMessage && (
        <div className={`alert ${statusMessage.includes("success") ? "alert-success" : "alert-danger"}`}>
          {statusMessage}
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group mb-3">
          <label className="form-label font-17 font-400 text-primary-green mb-1">Enter OTP</label>
          {/* <div className="d-flex justify-content-between gap-2">
            {otpDigits.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className="form-control text-center height-40 rounded-1 border-color-7D9199"
                style={{ width: "60px", height: "60px", fontSize: "24px", fontWeight: "600" }}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={(el) => (inputsRef.current[index] = el)}
              />
            ))}
          </div>
        </div> */}
          <div className="d-flex justify-content-center gap-2">
            {otpDigits.map((digit, index) => (
              <input
                key={index}
                type="text"
                inputMode="numeric"
                maxLength="1"
                className="form-control text-center height-40 rounded-1 border-color-7D9199"
                style={{ width: "60px", height: "60px", fontSize: "24px", fontWeight: "600" }}
                value={digit}
                onChange={(e) => handleChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={(el) => (inputsRef.current[index] = el)}
              />
            ))}
          </div>
        </div>

        <button type="submit" className="btn btn-primary-green w-100 height-50 rounded-1" disabled={isSubmitting}>
          {isSubmitting ? "Verifying..." : "Verify OTP"}
        </button>

        <div className="form-group d-flex justify-content-between mt-3">
          <button
            type="button"
            className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
            onClick={() => setActiveForm("login")}
          >
            ← Back to Login
          </button>
          <button
            type="button"
            className="text-decoration-none text-primary-green font-17 font-400 bg-white border-0"
            onClick={handleResend}
            disabled={isResending}
          >
            {isResending ? "Resending..." : "Resend OTP"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default OtpVerifyForm;

